import React from "react";
import "../../styles/Listing.css";
import "../../styles/ChecklistCard.css";
import ChecklistCard from "../../components/ChecklistCard.js";
import importantNotes from "../../data/BritishColumbia/importantNotes.js";
import ImportantNotes from "../../components/ImportantNotes.js";

export default function LetterOfOpinion() {
  const LOIData = [
    "Disclosure of Representation in Trading Services",
    "Fee for Service Agreement",
    "Copy of the Letter of Opinion",
  ];

  return (
    <div className="checklists flex flex-col items-center justify-center">
      <ChecklistCard
        province={"BC"}
        Title1={""}
        CheckListData={LOIData}
        Header="Letter Of Opinion"
      />
      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>

        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("letterOpinion") === true
          )}
        />
      </div>
    </div>
  );
}
